import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import type { PopoverMenuTouchableOptionProps as Option } from 'modules/core/components/PopoverMenu'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { useBulkImportSupplements } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { SHOW_DELETE_MODAL, UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'

interface DeleteBulkPopoverProps {
  bulkImportToDeleteId: number
  filename: string
}

const DeleteBulkPopover = ({ bulkImportToDeleteId, filename }: DeleteBulkPopoverProps) => {
  const { supplementDispatch } = useBulkImportSupplements()

  const showDeleteModal = () => {
    supplementDispatch({
      type: UPDATE_DATA,
      payload: {
        showManageImportedModal: false,
        bulkImportToDeleteId: bulkImportToDeleteId,
        filename,
      },
    })

    supplementDispatch({
      type: SHOW_DELETE_MODAL,
    })
  }

  const options: Option[] = [
    {
      onClick: showDeleteModal,
      title: i18n.t('payroll_bundle.delete_imported_supplements.title'),
      danger: true,
    },
  ]

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end" width="s300" disablePortal>
        {options.map(({ title, description, onClick, danger }, index) => (
          <PopoverMenu.TouchableOption
            key={index}
            danger={danger}
            title={title}
            onClick={onClick}
            description={description}
          />
        ))}
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default DeleteBulkPopover
